function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-356.000000, -188.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(367.000000, 199.000000) scale(1, -1) translate(-367.000000, -199.000000) translate(356.000000, 188.000000)"
}, React.createElement("path", {
  d: "M11,21.5510204 C17.0761905,21.5510204 22,16.7276968 22,10.7755102 C22,4.82332362 17.0761905,0 11,0 C4.92380952,0 0,4.82332362 0,10.7755102 C0,16.7276968 4.92380952,21.5510204 11,21.5510204 Z M11,2.05247813 C15.9238095,2.05247813 19.9047619,5.95218659 19.9047619,10.7755102 C19.9047619,15.5988338 15.9238095,19.4985423 11,19.4985423 C6.07619048,19.4985423 2.0952381,15.5988338 2.0952381,10.7755102 C2.0952381,5.95218659 6.07619048,2.05247813 11,2.05247813 Z"
}), React.createElement("path", {
  d: "M11,17.5102041 C14.8270616,17.5102041 17.9591837,14.4791182 17.9591837,10.7755102 C17.9591837,7.07190218 14.8270616,4.04081633 11,4.04081633 C7.17293837,4.04081633 4.04081633,7.07190218 4.04081633,10.7755102 C4.04081633,14.4791182 7.16967575,17.5102041 11,17.5102041 Z M11,6.06154023 C13.6786169,6.06154023 15.8711023,8.18330032 15.8711023,10.7755102 C15.8711023,13.3677201 13.6786169,15.4894802 11,15.4894802 C8.32138312,15.4894802 6.12563506,13.3677201 6.12563506,10.7755102 C6.12563506,8.18330032 8.3181205,6.06154023 11,6.06154023 Z"
}), React.createElement("path", {
  d: "M11,13.9183673 C12.6120199,13.9183673 13.9183673,12.6152375 13.9183673,11 C13.9183673,9.3847625 12.6152375,8.08163265 11,8.08163265 C9.3847625,8.08163265 8.08163265,9.38798011 8.08163265,11 C8.08163265,12.6120199 9.3847625,13.9183673 11,13.9183673 Z M11,10.1408996 C11.4794231,10.1408996 11.8591004,10.5173593 11.8591004,11 C11.8591004,11.4826407 11.4826407,11.8591004 11,11.8591004 C10.5173593,11.8591004 10.1408996,11.4794231 10.1408996,11 C10.1408996,10.5205769 10.5173593,10.1408996 11,10.1408996 Z"
}))));

const SvgGoalIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgGoalIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/goal-icon.48c0e49e.svg";
export { ForwardRef as ReactComponent };